export const DEFAULT_PUBLISH_DESCRIPTION_LIMIT = 120;

export const compactDefaultPublishDescription = (value?: string | null) => {
  const text = String(value || '').replace(/\s+/g, ' ').trim();
  if (text.length <= DEFAULT_PUBLISH_DESCRIPTION_LIMIT) return text;

  const sentences = text.match(/[^。！？]+[。！？]/g) || [];
  let completeSentences = '';
  for (const sentence of sentences.slice(0, 2)) {
    if (`${completeSentences}${sentence}`.length > DEFAULT_PUBLISH_DESCRIPTION_LIMIT) break;
    completeSentences += sentence;
  }
  if (completeSentences.length >= 40) return completeSentences;

  const visibleText = text.slice(0, DEFAULT_PUBLISH_DESCRIPTION_LIMIT);
  const sentenceEnd = Math.max(...['。', '！', '？'].map((mark) => visibleText.lastIndexOf(mark)));
  if (sentenceEnd >= 48) return visibleText.slice(0, sentenceEnd + 1);

  const suffix = '……';
  return `${text
    .slice(0, DEFAULT_PUBLISH_DESCRIPTION_LIMIT - suffix.length)
    .replace(/[，、；：\s]+$/g, '')}${suffix}`;
};
